export default __webpack_public_path__ + "static/media/photo_5282747746622312888_y.2af8be9e.jpg";